import React from 'react';
import { View, StyleSheet } from 'react-native';
import Button from './Button';
import { CommonProperties, CommonStyles, Color } from '../styles';

const BottomButton = ({ children, full, disabled, ...rest }) => {
  return (
    <View style={full ? null : styles.wrap}>
      {children}
      <Button
        labelStyle={CommonStyles.h2}
        style={[full ? null : styles.button, disabled && styles.disabled]}
        disabled={disabled}
        {...rest}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  button: {
    ...CommonProperties.py3,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
  },
  wrap: {
    ...CommonProperties.py3,
    ...CommonProperties.px3,
  },
  disabled: {
    backgroundColor: Color.disabled,
  },
});

export default BottomButton;
